export default __webpack_public_path__ + "1f6d542e08577a8f2a91dbdf9d109d16.jpeg";